import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AccountModel} from "../../angular/models/account.model";
import {AccountsAlerts} from "../../services/accounts-alerts.service";
import {$accountFactory} from "../../$account.factory";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {DepotsDialogService} from "../../../depots/services/depots-dialogs-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {AccountDialogService} from "../../services/account-dialogs-service.service";

export class ShipperAccountProvidersViewComponent implements IController {

  account: AccountModel;
  canUpdate: any;

  private accountRef: any;

  constructor(private accountsAlerts: AccountsAlerts, private IAMPermissions, private $log, private $account: $accountFactory,
              private accountDialogService: AccountDialogService, private confirmDialogService: ConfirmDialogService,
              private bringozLoaderService: BringozLoaderService) {
  }

  $onInit() {
    this.canUpdate = this.IAMPermissions.hasPermission('accounts.demand.update');
    this.accountRef = this.$account(this.account.id);
  };

  onAddProvider(event) {
    this.accountDialogService.setProvider(event, this.account.externalId)
      .then((payload: {name: string, data: {providerStoreId?: string}}) => {
        const accountCopy = angular.copy(this.account);

        if (!accountCopy.threePlProviderData) {
          accountCopy.threePlProviderData = {};
        }
        accountCopy.threePlProviderData[payload.name] = payload.data;

        // if (!accountCopy.threePlProviderData[payload.name]) {
        // _.unset(accountCopy.threePlProviderData, [payload.name])
        // }

        this.updateAccount(accountCopy);
      })
  }

  onEditProvider(event, providerName, providerData) {
    this.accountDialogService.setProvider(event, this.account.externalId, providerName, providerData)
      .then((payload: {name: string, data: {providerStoreId?: string}}) => {
        const accountCopy = angular.copy(this.account);

        if (!accountCopy.threePlProviderData) {
          accountCopy.threePlProviderData = {};
        }
        accountCopy.threePlProviderData[payload.name] = payload.data;

        this.updateAccount(accountCopy);
      })
  }

  private updateAccount(account: AccountModel, providerName?: string) {
    this.accountRef.$update(account)
      .then((updatedAccount) => {
        this.account = updatedAccount;
        this.accountsAlerts.demandAddExternalProviderSuccess(providerName);
      })
      .catch((error) => {
        if (error) {
          this.accountsAlerts.demandAddExternalProviderError();
          this.$log.error('Failed to update account @shipperAccountBranches@_updateAccount', error);
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }
}

angular
  .module('bringoz.admin.accounts')
  .component('shipperAccountProvidersView', {
    bindings: {
      account: '<'
    },
    template: require('./shipper-account-providers-view.html').default,
    controller: ShipperAccountProvidersViewComponent
  });
